import React from 'react';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Outlet } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Navbar data-id="element-2" />
      <main className="flex-grow" data-id="element-3">
        <Outlet data-id="element-4" />
      </main>
      <Footer data-id="element-5" />
    </div>;
}